<template>
  <v-footer dark padless v-if="hasFooter" class="bg-dark" color="#24292e">
    <v-card
      flat
      tile
      class="white--text text-center bg-dark"
      style="width:100%"
    >
      <v-tabs hide-slider background-color="#24292e" centered>
        <v-card-text
          class="white--text text-left"
          v-if="!$vuetify.breakpoint.xs"
        >
          © CUBICStars, Inc. All rights reserved.
        </v-card-text>
        <v-tab to="/subscription_plans" class="tab-active v-tab--active">
          plans
        </v-tab>
        <v-tab to="/help" class="tab-active v-tab--active">help</v-tab>
        <v-tab to="/terms" class="tab-active v-tab--active">terms</v-tab>
        <v-tab to="/privacy" class="tab-active v-tab--active">privacy</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-text class="white--text" v-if="$vuetify.breakpoint.xs">
        © CUBICStars, Inc. All rights reserved.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapGetters({
      hasFooter: 'option/getHasFooter',
    }),
  },
}
</script>

<style lang="scss">
footer {
  z-index: 2;
}
</style>
